import type DepartmentForOfficeRoom from './department-for-office-room';

class Department {
  id?: string;

  name = '';

  rooms: DepartmentForOfficeRoom[] = [];
}

export default Department;
